import { CameraForm } from './CameraForm';
import { DetailList, SearchExistingField } from '@skyline-platform/alchemy';
import { getDevices } from '@utils/graphql/creators/devices';
import PropTypes from 'prop-types';
import { getLogger } from '@utils/general';
import { getAddrLabel } from '@pages/utils/helpers';

const logger = getLogger('src.components.FormComponents.CameraForm.SearchExistingCamera');

export const SearchExistingCamera = ({ ...props }) => {
  const {
    formData,
    setFormData,
    lockDownFields,
  } = { ...props };

  /**
   * Camera is referred to as "Device" in the SSOT
   * but we want the frontend to say "camera" which is
   * why it might seem like there is a mismatch
   */
  const getAvailableDevices = async () => {
    const { query, execute } = lockDownFields?.device
      ? getDevices(lockDownFields.device.id)
      : getDevices();
    query.addReturnProperties('name', 'id', 'network_address');

    try {
      const res = await execute();
      const normalizedData = res.data.map((camera) => {
        return {
          ...camera,
          name: getAddrLabel(camera, 'network_address'),
        };
      });

      return {
        ...res,
        data: normalizedData,
      };
    } catch (error) {
      logger.error(error.message);
    }
  };

  return (
    lockDownFields?.device ?
      <DetailList keyValuePair={{ Camera: lockDownFields.device.name }} separator='' />
      :
      <SearchExistingField
        fieldName='Camera'
        required
        fetchData={getAvailableDevices}
        newFieldForm={(handleClose) => (
          <CameraForm
            cameraData={formData.camera}
            setFormData={setFormData}
            handleClose={handleClose}
          />
        )}
        {...props}
      />
  );
};

SearchExistingCamera.propTypes = {
  formData: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  lockDownFields: PropTypes.object,
};